<ng-container *ngIf="data">
  <ng-container *ngIf="shippingBucket; else noShippingBucket">
    <p data-testing-id="shippingMethodName">{{ shippingBucket.shippingMethod?.name }}</p>
    <div *ngIf="shippingBucket.desiredDeliveryDate">
      <strong>{{ 'checkout.widget.shipping_method.desired_delivery_date' | translate }}</strong>
      <p data-testing-id="desiredDeliveryDate">{{ shippingBucket.desiredDeliveryDate | ishDate }}</p>
    </div>
  </ng-container>
  <ng-template #noShippingBucket>
    <p data-testing-id="shippingMethodName">{{ data.commonShippingMethod?.name }}</p>
    <div *ngIf="desiredDeliveryDate">
      <strong>{{ 'checkout.widget.shipping_method.desired_delivery_date' | translate }}</strong>
      <p data-testing-id="desiredDeliveryDate">{{ desiredDeliveryDate | ishDate }}</p>
    </div>
  </ng-template>
</ng-container>
